import React from 'react';
import CualappLogo from './CualappLogo';

const LandingPage = () => {
  const goToLogin = () => { window.location.href = '/login'; };
  const goToOnboarding = () => { window.location.href = '/onboarding'; };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50" data-testid="landing-page">
      {/* Barra superior */}
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-6 py-5">
        <div className="flex items-center gap-3">
          <CualappLogo size={44} animated={true} />
          <div>
            <p className="text-lg font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent leading-tight">CUALAPP</p>
            <p className="text-[10px] uppercase tracking-wider text-gray-400">Beta privada</p>
          </div>
        </div>
        <button onClick={goToLogin} data-testid="landing-nav-login"
          className="text-sm text-gray-600 hover:text-purple-700 font-medium">
          Ya tengo cuenta
        </button>
      </nav>

      {/* Hero */}
      <section className="max-w-5xl mx-auto px-6 pt-8 pb-16 text-center">
        <div className="inline-block px-3 py-1 rounded-full bg-purple-100 text-purple-800 text-xs font-medium mb-6">
          Acceso solo por invitacion
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
          Un espacio para <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">coordinar la vida economica</span> con tu gente.
        </h1>
        <p className="mt-6 text-base sm:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
          CUALAPP es un ecosistema privado donde puedes enviar y recibir dinero, coordinar servicios y proyectos con personas de confianza, y proteger tus intercambios con reglas claras. Estamos creciendo por invitacion, con calma.
        </p>

        {/* CTA doble */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto">
          <button onClick={goToOnboarding} data-testid="landing-cta-request"
            className="w-full sm:w-auto px-6 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold text-sm shadow-md hover:shadow-lg transition-all">
            Solicitar mi invitacion
          </button>
          <button onClick={goToLogin} data-testid="landing-cta-login"
            className="w-full sm:w-auto px-6 py-3 rounded-lg bg-white border-2 border-purple-200 text-purple-700 font-semibold text-sm hover:border-purple-400 transition-all">
            Ingresar con codigo
          </button>
        </div>
        <p className="mt-4 text-xs text-gray-400">
          Las solicitudes las revisa personalmente el equipo. Respuesta en 24-72h.
        </p>
      </section>

      {/* Beneficios (3 cards) */}
      <section className="max-w-5xl mx-auto px-6 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-testid="landing-benefit-1">
            <div className="w-11 h-11 rounded-lg bg-purple-100 flex items-center justify-center text-2xl mb-4">💸</div>
            <h3 className="font-bold text-gray-900 mb-2">Envia y recibe dinero</h3>
            <p className="text-sm text-gray-600 leading-relaxed">Movimientos entre miembros con reglas claras, sin intermediarios opacos. Zelle, USDT y saldo interno.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-testid="landing-benefit-2">
            <div className="w-11 h-11 rounded-lg bg-blue-100 flex items-center justify-center text-2xl mb-4">🤝</div>
            <h3 className="font-bold text-gray-900 mb-2">Coordina con tu gente</h3>
            <p className="text-sm text-gray-600 leading-relaxed">Publica pedidos, ofrece servicios, transporte, encuestas y proyectos comunes con personas que ya estan dentro.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-testid="landing-benefit-3">
            <div className="w-11 h-11 rounded-lg bg-emerald-100 flex items-center justify-center text-2xl mb-4">🛡️</div>
            <h3 className="font-bold text-gray-900 mb-2">Protege tus intercambios</h3>
            <p className="text-sm text-gray-600 leading-relaxed">Escrow, verificacion de identidad y trazabilidad de cada acuerdo. Reglas parejas para todos.</p>
          </div>
        </div>
      </section>

      {/* Nota de confianza */}
      <section className="max-w-3xl mx-auto px-6 pb-20 text-center">
        <div className="border-t border-gray-200 pt-8">
          <p className="text-sm text-gray-500 leading-relaxed">
            Estamos abriendo la puerta poco a poco, con un usuario a la vez. No hay listas automaticas ni bots que aprueban solicitudes.
            Cada persona que entra fue invitada por alguien, o revisada personalmente por el equipo.
          </p>
          <div className="mt-6 flex justify-center gap-4 text-xs text-gray-400">
            <a href="/terms-beta" data-testid="landing-terms-link" className="hover:text-gray-700">Terminos</a>
            <span>·</span>
            <a href="/privacy" data-testid="landing-privacy-link" className="hover:text-gray-700">Privacidad</a>
            <span>·</span>
            <a href="mailto:soporte@cualapp.com" className="hover:text-gray-700">Contacto</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
